import { makeObservable, observable } from 'mobx';
import Painterro from 'painterro';
import './CanvasDrawing.scss';


export class CanvasDrawing {
    @observable isDrawModeActive = false;
    @observable isCanvasBlank = true;

    drawing: boolean;
    painterroInstance;

    constructor(private parentEl: HTMLElement) {
        makeObservable(this);
        //$('#canvas-drawing-wrapper').remove();
        //$('<div id="canvas-drawing-wrapper" style="display: block; position: absolute; top: 0; right: 0; bottom: 0; left : 0; z-index: 99"></div>').prependTo(this.parentEl)[0] as HTMLCanvasElement;
    }

    startDrawing = e => {
        this.hideMapToolbar();
        if (this.painterroInstance) {
            this.destroy();
        }
        this.isDrawModeActive = true;
        this.drawing = true;

        let i = 0;
        while ($('.textureCanvas')[i] != undefined) {
            ($('.textureCanvas')[i] as HTMLElement).style.display = 'none';
            i++;
        }

        const sizes = [3, 5, 10, 20, 40];
        this.painterroInstance = Painterro({
            id: this.parentEl.id,
            backgroundFillColor: '#ffffff',
            backgroundFillColorAlpha: 0.0,
            activeColor: '#EE6620',
            defaultTool: 'brush',
            defaultLineWidth: 3,
            replaceAllOnEmptyBackground: false,
            defaultPrimitiveShadowOn: false,
            defaultTextStrokeAndShadow: false,
            pixelizeHideUserInput: true,
            toolbarPosition: 'top',
            availableEraserWidths: sizes,
            availableFontSizes: sizes,
            availableLineWidths: sizes,
            extraFonts: [],
            hiddenTools: ['crop', 'rotate', 'resize', 'save', 'open', 'close', 'redo', 'zoomin', 'zoomout', 'bucket'],
            onChange: () => {
                const canvas = this.getCanvas();
                if (!canvas) return true;

                const blank = document.createElement('canvas');
                blank.width = canvas.width;
                blank.height = canvas.height;
                this.isCanvasBlank = canvas.toDataURL() == blank.toDataURL();
            }
        });

        // prevent painterro zooming, we never need it, drawing overlay needs to exactly match the map bellow
        this.painterroInstance.documentHandlers.wheel = () => { };
        this.painterroInstance.documentHandlers.touchmove = (e) => {
            if (e.touches.length === 1) {
                e.clientX = e.changedTouches[0].clientX;
                e.clientY = e.changedTouches[0].clientY;
                this.painterroInstance.documentHandlers.mousemove(e);
            }
        }
        Object.getPrototypeOf(this.painterroInstance).zoomImage = () => {}
        try {
            this.painterroInstance.show();
        } catch (e) { console.log('e:', e);}

        // relocate painterro toolbar since it doesn't allow us to change it parent element
        setTimeout(() => {
            $('button[title*=Brush]').prependTo('.ptro-bar > div');
            $('.ptro-bar').prependTo($('.ss-draw-wrapper'));
        }, 1);
    };

    endDrawing() {
        this.isDrawModeActive = false;
        this.destroy();
        this.drawing = false;
    }

    removeAll() {
        $('.textureCanvas').remove();
    }

    getCanvas(): HTMLCanvasElement {
        return document.querySelector('.ptro-wrapper canvas') as HTMLCanvasElement;
    }

    destroy() {
        this.showMapToolbar();
        $('.ptro-wrapper').remove();
        $('.ptro-bar').remove();
        this.painterroInstance = null;
    }

    hideMapToolbar = () => {
        $('#map-canvas-wrapper #controls').hide(); // 2d
        $('#toolbar-info-wrapper #controls').hide(); // 3d
    }

    showMapToolbar = () => {
        $('#map-canvas-wrapper #controls').show(); // 2d
        $('#toolbar-info-wrapper #controls').show(); // 3d
    }
}
